import { render } from "./PatientInfoSection.vue?vue&type=template&id=2a9b6be4&scoped=true"
import script from "./PatientInfoSection.vue?vue&type=script&lang=js"
export * from "./PatientInfoSection.vue?vue&type=script&lang=js"

import "./PatientInfoSection.vue?vue&type=style&index=0&id=2a9b6be4&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a9b6be4"]])

export default __exports__